<template>
  <div style="width: 100% ;padding: 10px">
    <div style="margin: 10px 0">
      <el-button type="primary" @click="add">添加工件</el-button>
      <el-button type="primary" @click="addWaixie">添加受托</el-button>
      <el-button type="primary" @click="drawer = true">工序模板管理</el-button>
      <el-button type="primary" @click="gongxuController = true">工序管理</el-button>
      <el-button type="primary" @click="changshangController = true">厂商管理</el-button>
      <el-input style="width: 200px" v-model="selectKey"></el-input>
      <el-button @click="getTableDateShow">筛选</el-button>
      <el-button @click="selectKey='',getTableDateShow()">重置</el-button>
      <el-button type="primary" @click="sortDialogVisible = true">排序设置</el-button>
  </div>
    <el-dialog title="排序设置" :visible.sync="sortDialogVisible" width="560px">
      <div v-for="(rule, index) in sortRules" :key="index" class="sort-rule-row">
        <el-select v-model="rule.prop" placeholder="排序字段" style="width: 200px" @change="getTableDateShow">
          <el-option
              v-for="option in sortOptions"
              :key="option.prop"
              :label="option.label"
              :value="option.prop"
              :disabled="isSortOptionDisabled(option.prop, index)">
          </el-option>
        </el-select>
        <el-select v-model="rule.order" placeholder="排序方式" style="width: 120px" @change="getTableDateShow">
          <el-option label="升序" value="ascending"></el-option>
          <el-option label="降序" value="descending"></el-option>
        </el-select>
        <el-button icon="el-icon-top" :disabled="index === 0" @click="moveSortRule(index, -1)"></el-button>
        <el-button icon="el-icon-bottom" :disabled="index === sortRules.length - 1" @click="moveSortRule(index, 1)"></el-button>
        <el-button type="danger" icon="el-icon-delete" @click="removeSortRule(index)"></el-button>
      </div>
      <div v-if="sortRules.length === 0" class="sort-empty">暂未设置排序规则</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clearSortRules">清空排序</el-button>
        <el-button type="primary" @click="addSortRule">添加排序</el-button>
        <el-button @click="sortDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!--    <div style="margin: 10px 0">
          <el-input v-model="search" placeholder="请输入姓名或工号" style="width:35%"></el-input>
          <el-button type="primary" style="margin-left:5px" @click = "selectkey">查询</el-button>
          <el-button type="primary" @click="remove">重置</el-button>
        </div>-->
    <el-table
        :data="tableDataShow"
        :default-sort="{prop: 'sendtime', order: 'descending'}"
        @sort-change="handleSortChange"
        border
        style="width: 100%">
      <el-table-column
          v-if="false"
          fixed="left"
          label="id"
          prop="id"
          width="100">
      </el-table-column>
      <el-table-column
          fixed="left"
          label="工件型号"
          prop="xinghao"
          sortable="custom"
          width="200">
      </el-table-column>
      <el-table-column
          fixed="left"
          label="图纸号"
          prop="tuzhihao"
          sortable="custom"
          width="200">
      </el-table-column>
      <el-table-column
          fixed="left"
          label="厂商"
          prop="changshang"
          sortable="custom"
          width="100">
      </el-table-column>
      <el-table-column
          label="工件数量"
          prop="number"
          sortable="custom"
          width="100">
      </el-table-column>
      <el-table-column
          label="入厂时间"
          prop="data"
          sortable="custom"
          width="130">
      </el-table-column>
      <el-table-column
          label="发货时间"
          prop="sendtime"
          sortable="custom"
          width="160">
      </el-table-column>
      <el-table-column
          label="工序1"
          prop="gongxu[0]"
          width="80">
      </el-table-column>
      <el-table-column
          label="工序2"
          prop="gongxu[1]"
          width="80">
      </el-table-column>
      <el-table-column
          label="工序3"
          prop="gongxu[2]"
          width="80">
      </el-table-column>
      <el-table-column
          label="工序4"
          prop="gongxu[3]"
          width="80">
      </el-table-column>
      <el-table-column
          label="工序5"
          prop="gongxu[4]"
          width="80">
      </el-table-column>
      <el-table-column
          label="工序6"
          prop="gongxu[5]"
          width="80">
      </el-table-column>
      <el-table-column
          label="工序7"
          prop="gongxu[6]"
          width="80">
      </el-table-column>
      <el-table-column
          label="工序8"
          prop="gongxu[7]"
          width="80">
      </el-table-column>
      <el-table-column
          label="工序9"
          prop="gongxu[8]"
          width="80">
      </el-table-column>
      <el-table-column
          label="工序10"
          prop="gongxu[9]"
          width="80">
      </el-table-column>
      <el-table-column
          label="工序11"
          prop="gongxu[10]"
          width="80">
      </el-table-column>
      <el-table-column
          label="工序12"
          prop="gongxu[11]"
          width="80">
      </el-table-column>
      <el-table-column
          label="工序13"
          prop="gongxu[12]"
          width="80">
      </el-table-column>
      <el-table-column
          label="工序14"
          prop="gongxu[13]"
          width="80">
      </el-table-column>
      <el-table-column
          label="工序15"
          prop="gongxu[14]"
          width="80">
      </el-table-column>
      <el-table-column
          fixed="right"
          label="操作"
          width="250">
        <template slot-scope="scope">
          <el-button size="small" type="text" @click="up(scope.row),upOrNew = 'up'">编辑</el-button>
          <el-button type="text" @click="getPhotoUrl(scope.row.xinghao+'(内部填报)')">查看二维码</el-button>
          <el-button type="text" :disabled="!scope.row.id" @click="createQR(scope.row.id,scope.row.xinghao+'(内部填报)')">生成二维码</el-button>
          <el-popconfirm title="确定删除吗？" @confirm = "deleterow(scope.row.id)">
            <el-button type="text" size="small" slot="reference">删除</el-button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin: 10px 0">
      <el-pagination
          :current-page="currentPage4"
          :page-size="size"
          :page-sizes="[5, 10, 20]"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <!--  编辑弹窗  -->
    <el-dialog title="选择待添加工件" :visible.sync="workpieceJdDialogVisible" width="70%">
      <div style="margin-bottom: 10px; display: flex; flex-wrap: wrap; gap: 8px;">
        <el-input
            v-model="workpieceJdSearch.orderCode"
            clearable
            placeholder="任务订单号"
            style="width: 160px"
            @keyup.enter.native="searchWorkpieceJd">
        </el-input>
        <el-input
            v-model="workpieceJdSearch.serialName"
            clearable
            placeholder="型号"
            style="width: 160px"
            @keyup.enter.native="searchWorkpieceJd">
        </el-input>
        <el-input
            v-model="workpieceJdSearch.paperNumber"
            clearable
            placeholder="图纸号"
            style="width: 160px"
            @keyup.enter.native="searchWorkpieceJd">
        </el-input>
        <el-input
            v-model="workpieceJdSearch.factory"
            clearable
            placeholder="厂商"
            style="width: 140px"
            @keyup.enter.native="searchWorkpieceJd">
        </el-input>
        <el-button type="primary" @click="searchWorkpieceJd">筛选</el-button>
        <el-button @click="resetWorkpieceJdSearch">重置</el-button>
      </div>
      <el-table
          :data="workpieceJdPageList"
          border
          v-loading="workpieceJdLoading"
          style="width: 100%">
        <el-table-column prop="orderCode" label="任务订单号" width="160"></el-table-column>
        <el-table-column prop="serialName" label="型号" width="180"></el-table-column>
        <el-table-column prop="paperNumber" label="图纸号" width="180"></el-table-column>
        <el-table-column prop="factory" label="厂商" width="120"></el-table-column>
        <el-table-column prop="number" label="投产数" width="100"></el-table-column>
        <el-table-column prop="intime" label="引入时间" width="180"></el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="selectWorkpieceJd(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 10px; text-align: right;">
        <el-pagination
            :current-page="workpieceJdCurrentPage"
            :page-size="workpieceJdPageSize"
            :page-sizes="[5, 10, 20, 50]"
            :total="workpieceJdFilteredList.length"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="handleWorkpieceJdSizeChange"
            @current-change="handleWorkpieceJdCurrentChange">
        </el-pagination>
      </div>
    </el-dialog>
    <el-dialog :before-close="handleClose2" :visible.sync="dialogVisible" width="50%">
      <el-form :model="form" label-width="80px">
        <el-form-item label="图纸号">
          <el-input v-if="isWaiXie" v-model="form.tuzhihao" @change="createSerious = false" :disabled="isWorkpieceJdSelected()" style="width: 90%"></el-input>
          <el-select
              v-if="isWaiXie === false"
              v-model="form.tuzhihao"
              filterable
              allow-create
              remote
              reserve-keyword
              placeholder="请输入关键词"
              @change="GetCmdbByPaper"
              :disabled="isWorkpieceJdSelected() || upOrNew !== 'new'"
              :remote-method="remoteMethod"
              :loading="loading">
            <el-option
                v-for="item in paperList"
                :key="item.value"
                :label="item.value"
                :value="item.value">
            </el-option>
          </el-select>

        </el-form-item>
        <el-form-item label="数量">
          <el-input v-model="form.number" :disabled="isWorkpieceJdSelected()" style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item label="发货时间">
          <el-date-picker
              v-model="form.sendtime"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="请选择发货日期"
              style="width: 90%">
          </el-date-picker>
        </el-form-item>
        <el-button v-if="isWorkpieceJdSelected()" @click="reselectWorkpieceJd">重新选择</el-button>
        <el-button v-if="upOrNew === 'new'" @click="seriousInpute(form.tuzhihao)">导入工序</el-button>
        <span style="padding-left: 10px;color: red">{{remark}}</span>
        <el-form-item label="型号" v-if="upOrNew !== 'new' || createSerious">
          <el-input v-if="isWaiXie" v-model="form.xinghao" style="width: 90%" :disabled="isWorkpieceJdSelected()" @change="form.chanpinCmdbId = null"></el-input>
          <el-select
              v-if="isWaiXie === false"
              v-model="form.xinghao"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod2"
              @change="getCmdbId(form.xinghao)"
              :disabled="isWorkpieceJdSelected() || !newPaper"
              :loading="loading2">
            <el-option
                v-for="item in xinghaoList"
                :key="item.id"
                :label="item.name"
                :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="自动生成原料出库单" v-if="upOrNew !== 'new' || createSerious">
          <el-switch
              v-model="propertyCostAuthSwitch">
          </el-switch>
        </el-form-item>
        <el-form-item label="厂商" v-if="upOrNew !== 'new' || createSerious">
          <el-select :disabled="isWorkpieceJdSelected() || (upOrNew === 'new' && !isNewSerious)" v-model="form.changshang" placeholder="请选择">
            <el-option
                v-for="item in facturyList"
                :key="item"
                :label="item"
                :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="upOrNew !== 'new' || (createSerious && isNewSerious)" label="加工工序">
          <div style="display:flex">
            <div style="width: 40%">
              <el-timeline>
                <el-timeline-item
                    v-for="(name, index) in gongxu"
                    :key="index">
                  <el-button type="text" @click="optionUpdate = true,optionIndex = index,optionUpdateValue=name">{{ name }}</el-button>
                </el-timeline-item>
              </el-timeline>
              <el-button @click="optionAdd">添加工序</el-button>
            </div>
            <div>
              <el-card class="box-card">
                <div slot="header" class="clearfix">
                  <span>工序模板</span>
                </div>
                <div v-for="(muban,i) in gongxumubanList">
                  <el-button type="text" @click="setMuban(muban.processList)">{{ muban.name }}</el-button>
                </div>
              </el-card>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false;gongxu=[];createSerious = false;">取 消</el-button>
        <el-button type="primary" @click="save()" v-if="(upOrNew !== 'new' || createSerious)">确 定</el-button>
      </span>
    </el-dialog>
    <!--  弹窗  -->
    <el-dialog :before-close="handleClose" :visible.sync="optionUpdate" width="50%">
      <div>
        工序删除
        <el-popconfirm title="确定删除吗？" @confirm = "gongxuRemove">
          <el-button type="text" slot="reference">删除</el-button>
        </el-popconfirm>
      </div>
      工序修改：
      <el-select v-model="optionUpdateValue" placeholder="请选择">
        <el-option
            v-for="item in options"
            :key="item"
            :label="item"
            :value="item">
        </el-option>
      </el-select>
      <el-button @click="gongxuUpdate" v-show="optionUpdateValue !== ''">修改</el-button>
    </el-dialog>

    <!--  侧边栏  -->
    <el-drawer
        title="工序模板"
        :visible.sync="drawer"
        :before-close="handleClose">
      <el-card class="box-card">
        <el-button type="primary" @click="gongxumubanAdd">新增</el-button>
        <el-collapse accordion v-for="(item,index) in gongxumubanList">
          <el-collapse-item>
            <template slot="title">
              <div v-if="!gongxumubanbianji">
                {{item.name }}
              </div>
            </template>
            <div style="display:flex">
              <el-button type="primary" v-if="!gongxumubanbianji" @click="gongxumubanbianji = true , gongxumuban=item">编辑</el-button>
              <div v-if="gongxumubanbianji" style="display:flex">
                <div style="width: 50px">名称: </div><el-input v-model="gongxumuban.name"></el-input>
              </div>
              <el-popconfirm title="确定删除吗？" v-if="gongxumubanbianji" @confirm = "delMoban(item.id,index)">
                <el-button type="primary" slot="reference">删除模板</el-button>
              </el-popconfirm>
            </div>
            <el-timeline>
              <el-timeline-item
                  v-for="(name, ind) in item.processList"
                  :key="ind">
                <span v-if="!gongxumubanbianji">{{name}}</span>
                <el-button type="text" v-if="gongxumubanbianji" @click="mubanUpdate = true,mubanIndex = ind,mubanUpdateValue=name,gongxumuban.processList = item.processList">{{name}}</el-button>
              </el-timeline-item>
            </el-timeline>
            <el-button v-if="gongxumubanbianji" @click="gongxuUpdateAdd">添加工序</el-button>
            <el-button type="primary" v-if="gongxumubanbianji" @click="gongxumubanbianjisave">保存</el-button>
          </el-collapse-item>
        </el-collapse>
      </el-card>
    </el-drawer>
    <!--  模板编辑弹窗  -->
    <el-dialog :before-close="handleClose" :visible.sync="mubanUpdate" width="50%">
      <div>
        工序删除
        <el-popconfirm title="确定删除吗？" @confirm = "gongxuMubanRemove">
          <el-button type="text" slot="reference">删除</el-button>
        </el-popconfirm>
      </div>
      工序修改：
      <el-select v-model="mubanUpdateValue" placeholder="请选择">
        <el-option
            v-for="item in options"
            :key="item.process"
            :label="item.process"
            :value="item"
            :disabled="gongxumuban.processList.includes(item.process)">
        </el-option>
      </el-select>
<!--      <el-select v-model="mubanUpdatetap" v-show="mubanUpdateValue.tap.length !== 0" placeholder="请选择">-->
<!--        <el-option-->
<!--            v-for="item in mubanUpdateValue.tap"-->
<!--            :key="item"-->
<!--            :label="item"-->
<!--            :value="item">-->
<!--        </el-option>-->
<!--      </el-select>-->
      <el-button @click="gongxuMubanUpdate" v-show="mubanUpdateValue !== ''">修改</el-button>
    </el-dialog>
    <!--  工序添加弹窗  -->
    <el-dialog title="添加工序" :before-close="handleClose" :visible.sync="gongxuController" width="50%">
      <el-select
          v-model="gongxuAdd"
          filterable
          allow-create
          default-first-option
          placeholder="请输入工序名称"
          @change = "AddTap(gongxuAdd)">
        <el-option
            v-for="item in gongxuOptions"
            :key="item"
            :label="item"
            :value="item">
        </el-option>
      </el-select>
      <el-popconfirm title="工序添加后不可修改或删除，确定添加该工序吗？" v-if='!tapadd' @confirm = "gongxuAddInList">
        <el-button slot="reference">添加</el-button>
      </el-popconfirm>
      <el-select
          v-if='tapadd'
          v-model="gongxuTapAdd"
          filterable
          allow-create
          default-first-option
          placeholder="请输入工序标签">
        <el-option
            v-for="item in tapOptions"
            :key="item"
            :label="item"
            :value="item">
        </el-option>
      </el-select>
      <span v-if='tapOptions != null && tapOptions.includes(gongxuTapAdd)'>工序标签已存在</span>
      <el-popconfirm title="工序标签添加后不可修改或删除，确定添加该工序标签吗？" v-if='tapOptions != null && gongxuTapAdd != null && gongxuTapAdd != "" && !tapOptions.includes(gongxuTapAdd)' @confirm = "gongxuTapAddInList">
        <el-button slot="reference">添加</el-button>
      </el-popconfirm>
    </el-dialog>
    <!--  厂商添加弹窗  -->
    <el-dialog title="添加厂商" :before-close="handleClose" :visible.sync="changshangController" width="50%">
      <el-select
          v-model="changshangAdd"
          filterable
          allow-create
          default-first-option
          placeholder="请输入厂商名称">
        <el-option
            v-for="item in facturyList"
            :key="item"
            :label="item"
            :value="item">
        </el-option>
      </el-select>
      <span v-if='facturyList.includes(changshangAdd)'>厂商已存在</span>
      <el-popconfirm title="厂商添加后不可修改或删除，确定添加改厂商吗？" v-if='!facturyList.includes(changshangAdd)' @confirm = "changshangAddInList">
        <el-button slot="reference">添加</el-button>
      </el-popconfirm>
    </el-dialog>
    <!--  选择原料方案  -->
    <el-dialog title="选择原料方案" :before-close="handleClose" :visible.sync="propertyCostAuthCheck" width="50%">
      <el-select
          v-model="propertyCostId"
          filterable
          default-first-option
          @change="propertyCostAuthCheck=false"
          placeholder="请选择原料方案">
        <el-option
            v-for="item in propertyCostList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
      <span v-if='facturyList.includes(changshangAdd)'>厂商已存在</span>
      <el-popconfirm title="厂商添加后不可修改或删除，确定添加改厂商吗？" v-if='!facturyList.includes(changshangAdd)' @confirm = "changshangAddInList">
        <el-button slot="reference">添加</el-button>
      </el-popconfirm>
    </el-dialog>
    <!--  弹窗  -->
    <el-dialog :visible.sync="showQR" :title="name" width="20%" destroy-on-close>
      <img :src="(url)" alt="" style="width: 100%">
      <el-button @click="img_download()">下载</el-button>
    </el-dialog>
  </div>
</template>

<script>

import request from "@/utils/request";
import requestTicket from "@/utils/requestTicket";
import * as vm from "vm";
import TicketCreator from "@/utils/ticketCreator";

export default {
  data() {
    return {
      options: [],
      gongxuOptions:[],
      tapOptions:[],
      tapadd: true,
      gongxuController: false,//工序添加弹窗
      gongxuAdd: {
        process:"",
        tap:[]
      },//添加工序
      gongxuTapAdd: "",//添加工序
      changshangController: false,//厂商添加弹窗
      changshangAdd: "",//添加厂商
      drawer: false,//侧边栏
      mubanUpdate: false,//模板编辑弹窗
      form: {},
      optionUpdate: false,
      optionUpdateValue: "",
      optionTabUpdateList: [],
      optionTabUpdateValue: "",
      optionIndex: 0,
      mubanUpdateValue: {process:'',tap:[]},
      mubanUpdatetap: {},
      mubanIndex: 0,
      dialogVisible: false,
      isWaiXie: false,
      showQR: false,
      url: "",
      QRName: "",
      search: '',
      currentPage4: 1,
      size: 10,
      total: 0,
      tableData: [],
      tableDataShow: [],
      sortDialogVisible: false,
      sortRules: [
        {prop: "sendtime", order: "descending"}
      ],
      sortOptions: [
        {label: "工件型号", prop: "xinghao", type: "string"},
        {label: "图纸号", prop: "tuzhihao", type: "string"},
        {label: "厂商", prop: "changshang", type: "string"},
        {label: "工件数量", prop: "number", type: "number"},
        {label: "入厂时间", prop: "data", type: "date"},
        {label: "发货时间", prop: "sendtime", type: "date"}
      ],
      upOrNew: '',
      gongxu: [],
      gongxumubanList:[],//工序模板列标
      facturyList:[],//厂商列标
      gongxumuban: {
        id: 0,
        name: "",
        processList: []
      },
      gongxumubanbianji: false,//模板编辑按钮显隐
      createSerious:false,
      isNewSerious:false,
      remarkList:[],
      remark:"",
      newPaper:false,
      loading: false,
      paperList: [],
      paperListTotal: [],

      loading2: false,
      xinghaoList: [],
      xinghaoListTotal: [],

      propertyCostAuthSwitch:false,

      propertyCostAuthCheck:false,
      propertyCostList:[],
      propertyCostId:0,

      workpieceJdDialogVisible: false,
      workpieceJdLoading: false,
      workpieceJdPendingList: [],
      workpieceJdSearch: {
        orderCode: "",
        serialName: "",
        paperNumber: "",
        factory: ""
      },
      workpieceJdCurrentPage: 1,
      workpieceJdPageSize: 10,
      selectedWorkpieceJd: null,

      selectKey: ""
    }
  },
  //加载表格
  mounted() {
    this.select()
    this.GetFactury()
    this.GetGongxu()
    this.GetPaperListTotal()
    this.GetXinghaoListTotal()
  },
  watch:{
    propertyCostAuthSwitch(newVal, oldVal){
      if(newVal){
        this.getPropertyCostList()
        this.propertyCostAuthCheck = (this.propertyCostList.length>1)
        if(this.propertyCostList.length === 0){
          this.propertyCostAuthSwitch = false
          this.$notify.error({
            title: '错误',
            message: '当前型号未配置原料'
          });
        }
      } else {
        this.propertyCostList = []
      }
    },
    workpieceJdSearch: {
      handler() {
        this.workpieceJdCurrentPage = 1
      },
      deep: true
    }
  },
  computed: {
    workpieceJdFilteredList() {
      const contains = (value, keyword) => {
        return keyword === "" || ((value || "").toString().toLowerCase().indexOf(keyword.toLowerCase()) > -1)
      }
      const search = this.workpieceJdSearch
      return this.workpieceJdPendingList.filter(item => {
        return contains(item.orderCode, search.orderCode)
            && contains(item.serialName, search.serialName)
            && contains(item.paperNumber, search.paperNumber)
            && contains(item.factory, search.factory)
      })
    },
    workpieceJdPageList() {
      const start = (this.workpieceJdCurrentPage - 1) * this.workpieceJdPageSize
      return this.workpieceJdFilteredList.slice(start, start + this.workpieceJdPageSize)
    }
  },
  methods: {
    AddTap(option){
      if (this.gongxuOptions.includes(option)){
        for (let i = 0; i < this.options.length; i++) {
          if (option == this.options[i].process){
            this.tapOptions = this.options[i].tap
            this.tapadd = true
          }
        }
      } else {
        this.tapadd = false
      }
    },
    //新增
    add() {
      this.remark = ""
      this.remarkList = []
      this.isWaiXie = false
      this.form = {}
      this.upOrNew = 'new'
      this.selectedWorkpieceJd = null
      this.loadWorkpieceJdPending()
      this.workpieceJdDialogVisible = true
    },
    isWorkpieceJdSelected() {
      return this.upOrNew === 'new' && this.form && this.form.workpieceJdId != null
    },
    loadWorkpieceJdPending() {
      this.workpieceJdLoading = true
      request.get("/syn/workpiece-jd/pending").then(res => {
        if (res.code && res.code.toString() === "200") {
          this.workpieceJdPendingList = res.data || []
          this.fixWorkpieceJdCurrentPage()
        } else {
          this.$notify.error({
            title: '错误',
            message: res.code + ":" + res.msg
          });
        }
      }).finally(() => {
        this.workpieceJdLoading = false
      })
    },
    searchWorkpieceJd() {
      this.workpieceJdCurrentPage = 1
    },
    resetWorkpieceJdSearch() {
      this.workpieceJdSearch = {
        orderCode: "",
        serialName: "",
        paperNumber: "",
        factory: ""
      }
      this.workpieceJdCurrentPage = 1
    },
    handleWorkpieceJdSizeChange(val) {
      this.workpieceJdPageSize = val
      this.workpieceJdCurrentPage = 1
    },
    handleWorkpieceJdCurrentChange(val) {
      this.workpieceJdCurrentPage = val
      this.fixWorkpieceJdCurrentPage()
    },
    fixWorkpieceJdCurrentPage() {
      const pageMax = Math.ceil(this.workpieceJdFilteredList.length / this.workpieceJdPageSize)
      this.workpieceJdCurrentPage = this.workpieceJdCurrentPage > pageMax ? pageMax : this.workpieceJdCurrentPage
      this.workpieceJdCurrentPage = this.workpieceJdCurrentPage < 1 ? 1 : this.workpieceJdCurrentPage
    },
    selectWorkpieceJd(row) {
      this.selectedWorkpieceJd = row
      this.isWaiXie = !!(row.isWaiXie === undefined ? row.waiXie : row.isWaiXie)
      this.form = {
        xinghao: row.serialName,
        tuzhihao: row.paperNumber,
        changshang: row.factory,
        number: row.number,
        sendtime: row.sendtime,
        workpieceJdId: row.id,
        jdOrderLineId: row.orderLineId,
        jdOrderId: row.orderId,
        jdOrderCode: row.orderCode
      }
      this.gongxu = []
      this.workpieceJdDialogVisible = false
      this.dialogVisible = true
      if (this.form.tuzhihao) {
        this.GetCmdbByPaper()
        this.seriousInpute(this.form.tuzhihao)
      }
    },
    reselectWorkpieceJd() {
      this.dialogVisible = false
      this.form = {}
      this.gongxu = []
      this.remark = ""
      this.remarkList = []
      this.createSerious = false
      this.isNewSerious = false
      this.selectedWorkpieceJd = null
      this.loadWorkpieceJdPending()
      this.workpieceJdDialogVisible = true
    },
    addWaixie() {
      this.remark = ""
      this.remarkList = []
      this.dialogVisible = true
      this.isWaiXie = true
      this.form = {}
      this.upOrNew = 'new'
    },
    seriousInpute(tuzhihao){
      this.remark=""
      this.remarkList=[]
      request.post("/isNewSerious",tuzhihao).then(res =>{
        if (res.code === "200"){
          if (res.data.processes.length > 0){
            this.isNewSerious = false;

            let processList = res.data.processes;
            this.form.gongxu = processList;

            if (!this.isWorkpieceJdSelected()) {
              this.form.xinghao = res.data.serial.name;
              this.form.tuzhihao = res.data.serial.code;
              this.form.changshang = res.data.serial.factory;
            }
            this.form.serialId = res.data.serial.id;
          } else {
            this.isNewSerious = true;
          }
          this.$forceUpdate();
        }else {
          this.$notify.error({
            title: '错误',
            message: res.code + ":" + res.msg
          });
        }
      })
      this.createSerious = true;
      this.GetRemark(tuzhihao)
    },
    GetRemark(tuzhihao){
      request.post("/getRemark",tuzhihao).then(res =>{
        if (res.code === "200"){
          this.remarkList = res.data
          let num = 0
          for (let i = 0; i < res.data.length; i++) {
            if (res.data[i].caozuo === "下批次重新加工") {
              num += res.data[i].scrapNumbers
            }
          }
          if (num !== 0){
            this.remark = "之前批次转结共 " + num + " 件"
          }
        }else {
          this.$notify.error({
            title: '错误',
            message: res.code + ":" + res.msg
          });
        }
      })
    },
    gongxuAddInList() {
      if (this.gongxuAdd == {}){
        this.$notify.error({
          title: '错误',
          message: '添加工序为空'
        });
      } else {
        request.post("/AddGongxu",this.gongxuAdd).then(res =>{
          if (res.code == "200"){
            this.$notify({
              title: '成功',
              message: res.data,
              type: 'success',
            });
            this.GetGongxu();
            this.gongxuController = false
          }else {
            this.$notify.error({
              title: '错误',
              message: res.code + ":" + res.msg
            });
          }
        })
      }
    },
    gongxuTapAddInList() {
      if (this.gongxuTapAdd ==""){
        this.$notify.error({
          title: '错误',
          message: '添加工序为空'
        });
      } else {
        let pos = {
          process: this.gongxuAdd,
          tap: this.gongxuTapAdd
        }
        request.post("/AddGongxuTap",pos).then(res =>{
          if (res.code == "200"){
            this.$notify({
              title: '成功',
              message: res.data,
              type: 'success',
            });
            this.GetGongxu;
            this.gongxuController = false
            this.tapadd = false
          }else {
            this.$notify.error({
              title: '错误',
              message: res.code + ":" + res.msg
            });
          }
        })
      }
    },
    changshangAddInList() {
      if (this.changshangAdd ==""){
        this.$notify.error({
          title: '错误',
          message: '添加工序为空'
        });
      } else {
        request.post("/AddFactury",this.changshangAdd).then(res =>{
          if (res.code == "200"){
            this.$notify({
              title: '成功',
              message: res.data,
              type: 'success',
            });
            this.facturyList.push(this.changshangAdd)
            this.changshangController = false
          }else {
            this.$notify.error({
              title: '错误',
              message: res.code + ":" + res.msg
            });
          }
        })
      }
    },
    getPropertyCostList(){
      request.get("/cmdb-cost/selectByCostId/"+this.form.chanpinCmdbId).then(res =>{
        this.propertyCostList = res.data
      })
    },
    //编辑表单回显
    up(row) {
      this.remark = ""
      this.remarkList = []
      this.form = {
        id: row.id,
        xinghao: row.xinghao,
        tuzhihao: row.tuzhihao,
        changshang: row.changshang,
        number: row.number,
        sendtime: row.sendtime,
        serialId: row.serialId,
        gongxu: row.gongxu,
      }
      this.gongxu = Array.from(new Set(row.gongxu))
      this.isWaiXie = !!row.isWaiXie;
      if(this.gongxu.indexOf("无") !== -1){
        this.gongxu.splice(this.gongxu.indexOf("无"), 1)
      }
      this.dialogVisible = true
    },
    //删除按钮
    deleterow(id) {
      request.post("/ArtifactManageDel",id).then(res =>{
        if (res.code == "200"){
          this.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success',
          });
          this.select();
        }else {
          this.$notify.error({
            title: '错误',
            message: res.code + ":" + res.msg
          });
        }
      })
    },
    //删除按钮
    delMoban(id,index) {
      request.post("/DelMoban",id).then(res =>{
        if (res.code == "200"){
          this.$notify({
            title: '成功',
            message: res.data,
            type: 'success',
          });
          this.gongxumubanList.splice(index, 1)
          this.mubanUpdate = false;
          //this.drawer = false;
          this.gongxumubanbianji = false;
        }else {
          this.$notify.error({
            title: '错误',
            message: res.code + ":" + res.msg
          });
        }
      })
    },
    gongxumubanbianjisave() {
      request.post("/MuBanUpdate",this.gongxumuban).then(res =>{
        if (res.code == "200"){
          this.$notify({
            title: '成功',
            message: res.data,
            type: 'success',
          });
          this.gongxumubanbianji = false;
        }else {
          this.$notify.error({
            title: '错误',
            message: res.code + ":" + res.msg
          });
        }
      })
      this.GetMoban()
      this.drawer = false
    },
    log(form){
    },
    //保存
    save() {
      this.form.gongxu = this.gongxu;
      this.form.waiXie = this.isWaiXie
      if (this.form.xinghao == null || this.form.changshang == null || this.form.tuzhihao == null || this.form.number == null) {
        this.$notify.error({
          title: '错误',
          message: "请录入完整信息"
        });
      } else {
        if (this.upOrNew === 'new') {
          request.post("/AddWorkpiece", this.form).then(res => {
            if (res.code.toString() === "200") {
              this.$notify({
                title: '成功',
                message: '修改成功',
                type: 'success'
              });
              //this.tableData.push(this.form)
              this.dialogVisible = false
              this.form = {}
              this.select();
            } else {
              this.$notify.error({
                title: '错误',
                message: res.code + ":" + res.msg
              });
            }
          })
          this.propertyCostAuth();
          // 创建生产单
          this.createProductionTicket();
          /*
          * /CMDB/propertyCost
          * */
        } else if (this.upOrNew == 'up') {
          request.post("/UpdateWorkpiece", this.form).then(res => {
            if (res.code.toString() === "200") {
              this.$notify({
                title: '成功',
                message: '编辑成功',
                type: 'success'
              });
              //this.tableData.push(this.form)
              this.dialogVisible = false
              this.form = {}
              this.select();
            } else {
              this.$notify.error({
                title: '错误',
                message: res.code + ":" + res.msg
              });
            }
          })
        } else {
          this.$notify.error({
            title: '错误',
            message: '添加或修改发生意外'
          });
        }
      }
    },

    // 创建生产单方法
    createProductionTicket() {
      // 构造生产单数据
      const ticketData = {
        name: this.form.xinghao + "生产单", // 工单名称
        personResponsible: "", // 责任人，需要从用户信息获取
        submitter: "", // 提交人，需要从用户信息获取
        reviewer: "", // 审核人
        department: "", // 部门
        collectionsTime: "", // 收款时间
        billType: "", // 票据类型
        correspondents: this.form.changshang, // 往来单位（使用厂商）
        warehouse: "", // 流转仓库
        summary: `生产${this.form.number}件${this.form.xinghao}产品`, // 摘要信息
        barcodes: "", // 条码
        scansNumber: this.form.number, // 扫描数量（使用生产数量）
        remark: `图纸号：${this.form.tuzhihao}`, // 附加说明
        saleType: "", // 销售类型
        paymentAccount: "", // 付款账户
        payment: "", // 付款金额
        discount: "", // 整单折扣
        preferential: "", // 优惠
        prepaidAmount: "" // 预付金额
      };

      // 获取当前用户信息
      const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {};
      if (user.name) {
        ticketData.personResponsible = user.name; // 责任人
        ticketData.submitter = user.name; // 提交人
      }

      // 使用TicketCreator创建完整单据
      const ticketType = 3; // 生产单类型ID
      const processId = 1; // 假设流程ID为1，需要根据实际情况调整
      
      const completeTicket = TicketCreator.createCompleteTicket(
        { 
          ...ticketData, 
          ticketType: ticketType 
        },
          // 创建单据行信息
        [
          {
            name: "", // 名称
            materialName: this.form.xinghao, // 物料名称
            material_type_id: "",
            number: this.form.number, // 数量
            price: "", // 单价
            money: "", // 金额
            discount: "", // 折扣
            discountPrice: "", // 折后单价
            comment: `图纸号：${this.form.tuzhihao}`, // 备注
            costitemCode: "", // 费用项目编号
            costitemName: "", // 费用项目名称
            incomeSubjectCode: "", // 收入科目编号
            incomeSubjectName: "" // 收入科目名称
          }
        ],
        { 
          processId: processId, 
          processIndex: 1 // 假设初始流程索引为1
        }
      );

      console.log("创建的生产单:", completeTicket);
      
      // 调用后端API来保存生产单
      requestTicket.post('/Ticketing/ticket/save', completeTicket.ticket).then(res => {
        if (res.code === "200") {
          // 保存历史记录
          const ticketHis = {
            ...completeTicket.ticketHistory,
            tickedId: res.data.id
          };
          
          requestTicket.post('/Ticketing/ticket-his/save', ticketHis).then(hisRes => {
            if (hisRes.code === "200") {
              console.log("生产单历史记录创建成功");
            } else {
              console.error("生产单历史记录创建失败:", hisRes.msg);
            }
          });
        } else {
          console.error("生产单创建失败:", res.msg);
        }
      }).catch(error => {
        console.error("创建生产单时发生错误:", error);
      });
    },

    propertyCostAuth(){
      if (this.propertyCostList.length === 1){
        request.post("/CMDB/propertyCostAuth/"+this.form.chanpinCmdbId+"/"+this.form.number).then(res => {
          if (res.code == "200") {
            this.$notify({
              title: '成功',
              message: '出库单生成成功',
              type: 'success'
            });
            //this.tableData.push(this.form)
            this.dialogVisible = false
            this.form = {}
            this.select();
          } else {
            this.$notify.error({
              title: '错误',
              message: res.code + ":" + res.msg
            });
          }
        })
      } else {
        request.post("/CMDB/propertyCost/"+this.propertyCostId+"/"+this.form.number).then(res => {
          if (res.code == "200") {
            this.$notify({
              title: '成功',
              message: '出库单生成成功',
              type: 'success'
            });
            //this.tableData.push(this.form)
            this.dialogVisible = false
            this.form = {}
            this.select();
          } else {
            this.$notify.error({
              title: '错误',
              message: res.code + ":" + res.msg
            });
          }
        })
      }
    },
    //整表查询
    select() {
      request.post("/ArtifactManage").then(res => {
        this.total = res.data.length;
        this.tableData = res.data
        this.getTableDateShow();
      })
      this.GetMoban()
    },
    GetMoban(){
      request.post("/GetMoban").then(res => {
        this.gongxumubanList = res.data
      })
    },
    GetPaperListTotal(){
      request.post("/CMDB/getPaperList").then(res => {
        this.paperListTotal = res.data
      })
    },
    GetXinghaoListTotal(){
      request.post("/CMDB/getPropertyChildren","产品列表").then(res => {
        this.xinghaoListTotal = res.data
      })
    },
    GetCmdbByPaper(){
      this.createSerious = false
      request.post("/CMDB/GetCmdbByPaper",this.form.tuzhihao).then(res => {
        let _cmdb = res.data
        if (this.isEmptyString(_cmdb.name)){
          this.newPaper = true;
        } else {
          this.newPaper = false;
          if (!this.isWorkpieceJdSelected()) {
            this.form.xinghao = _cmdb.name
          }
          this.form.chanpinCmdbId = _cmdb.id
        }
      })
    },
    GetGongxu() {
      request.post("/GetGongxu").then(res => {
        this.options = res.data
        if (this.options.length>0){
          this.gongxuAdd = this.options[0];
          let gongxuOption = []
          for (let i = 0; i < this.options.length; i++) {
            gongxuOption.push(this.options[i])
          }
          this.gongxuOptions = gongxuOption;
        }
      })
    },
    GetFactury(){
      request.post("/GetFactury").then(res => {
        this.facturyList = res.data;
      })
    },
    setMuban(list) {
      this.gongxu = list
    },
    //关键字查询
    // selectkey() {
    //   if (parseInt(this.search) > 0) {
    //     request.post("/EmployeeAuthoritySelectId", parseInt(this.search)).then(res => {
    //       this.tableData = res.data
    //     })
    //   } else {
    //     request.post("/EmployeeAuthoritySelectName", this.search).then(res => {
    //       this.tableData = res.data
    //     })
    //   }
    // },
    //编辑
    update() {
      request.post("/EmployeeAuthority", this.form).then(res => {
        if (res.code == "200") {
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success'
          });
          this.dialogVisible = false
          this.form = {}
          this.select();
        } else {
          this.$notify.error({
            title: '错误',
            message: res.code + ":" + res.msg
          });
        }
      })
    },
    //重置
    remove() {
      this.search = ''
      this.select();
    },
    handleClose2(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            this.createSerious = false;
            done();
          })
          .catch(_ => {
          });
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {
          });
    },
    handleSizeChange(val) {
      this.size = val;
      this.getTableDateShow();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val
      this.getTableDateShow();
    },
    handleSortChange({prop, order}) {
      if (!prop) {
        return;
      }
      if (!order) {
        this.sortRules = this.sortRules.filter(rule => rule.prop !== prop);
      } else {
        this.sortRules = [{prop, order}];
      }
      this.getTableDateShow();
    },
    addSortRule() {
      const option = this.sortOptions.find(item => !this.sortRules.some(rule => rule.prop === item.prop));
      if (!option) {
        this.$message.info("已添加全部可排序字段");
        return;
      }
      this.sortRules.push({
        prop: option.prop,
        order: "ascending"
      });
      this.getTableDateShow();
    },
    removeSortRule(index) {
      this.sortRules.splice(index, 1);
      this.getTableDateShow();
    },
    moveSortRule(index, step) {
      const targetIndex = index + step;
      if (targetIndex < 0 || targetIndex >= this.sortRules.length) {
        return;
      }
      const rule = this.sortRules.splice(index, 1)[0];
      this.sortRules.splice(targetIndex, 0, rule);
      this.getTableDateShow();
    },
    clearSortRules() {
      this.sortRules = [];
      this.getTableDateShow();
    },
    getSortOption(prop) {
      return this.sortOptions.find(option => option.prop === prop) || {};
    },
    isSortOptionDisabled(prop, currentIndex) {
      return this.sortRules.some((rule, index) => index !== currentIndex && rule.prop === prop);
    },
    getSortValue(row, prop) {
      return prop.split(".").reduce((value, key) => {
        if (value === null || value === undefined) {
          return undefined;
        }
        return value[key];
      }, row);
    },
    compareSortValue(left, right, type) {
      const leftEmpty = left === null || left === undefined || left === "";
      const rightEmpty = right === null || right === undefined || right === "";
      if (leftEmpty && rightEmpty) {
        return 0;
      }
      if (type === "number") {
        const leftNumber = Number(left);
        const rightNumber = Number(right);
        if (!Number.isNaN(leftNumber) && !Number.isNaN(rightNumber)) {
          return leftNumber - rightNumber;
        }
      }
      if (type === "date") {
        const leftTime = Date.parse(left);
        const rightTime = Date.parse(right);
        if (!Number.isNaN(leftTime) && !Number.isNaN(rightTime)) {
          return leftTime - rightTime;
        }
      }
      return String(left).localeCompare(String(right), "zh-CN", {
        numeric: true,
        sensitivity: "base"
      });
    },
    applySortRules(list) {
      if (this.sortRules.length === 0) {
        return list;
      }
      return list.concat().sort((leftRow, rightRow) => {
        for (let i = 0; i < this.sortRules.length; i++) {
          const rule = this.sortRules[i];
          const option = this.getSortOption(rule.prop);
          const leftValue = this.getSortValue(leftRow, rule.prop);
          const rightValue = this.getSortValue(rightRow, rule.prop);
          const leftEmpty = leftValue === null || leftValue === undefined || leftValue === "";
          const rightEmpty = rightValue === null || rightValue === undefined || rightValue === "";
          if (leftEmpty || rightEmpty) {
            if (leftEmpty && rightEmpty) {
              continue;
            }
            return leftEmpty ? 1 : -1;
          }
          const result = this.compareSortValue(leftValue, rightValue, option.type);
          if (result !== 0) {
            return rule.order === "descending" ? -result : result;
          }
        }
        return 0;
      });
    },

    getTableDateShow(){

      let _tableData = this.tableData.concat()
      if (this.selectKey !== ""){
        _tableData = _tableData.filter(item => (item.xinghao.includes(this.selectKey) || item.tuzhihao.includes(this.selectKey)))

      }
      this.total = _tableData.length
      _tableData = this.applySortRules(_tableData)

      let _pageMax = Math.ceil(this.total/this.size)
      this.currentPage4 = this.currentPage4>_pageMax ? _pageMax :this.currentPage4;
      this.currentPage4 = this.currentPage4 < 1 ? 1 : this.currentPage4

      this.tableDataShow = _tableData.slice((this.currentPage4-1)*this.size,this.currentPage4*this.size);
    },
    handleEdit(row) {
    },
    optionAdd() {
      this.optionUpdateValue = ""
      this.optionIndex = this.gongxu.length
      this.optionUpdate = true
    },
    gongxuUpdateAdd() {
      this.mubanUpdateValue = ""
      if(this.gongxumuban.processList !== undefined && this.gongxumuban.processList !== null){
        this.mubanIndex = this.gongxumuban.processList.length
      } else {
        this.mubanIndex = 0;
      }
      this.mubanUpdate = true
    },
    gongxuUpdate() {
      if (this.optionIndex == this.gongxu.length){
        this.gongxu.push(this.optionUpdateValue)
        this.optionUpdate = false
      }else {
        this.gongxu.splice(this.optionIndex, 1,this.optionUpdateValue)
        this.optionUpdate = false
      }
    },
    gongxuMubanUpdate() {
      if (this.mubanUpdateValue == null || this.mubanUpdateValue.process == ""){
        this.$notify.error({
          title: '错误',
          message: '请选择工序'
        });
      } else {
        if (this.mubanIndex == this.gongxumuban.processList.length){
          this.gongxumuban.processList.push(this.mubanUpdateValue)
          this.mubanUpdate = false
        }else {
          this.gongxumuban.processList.splice(this.mubanIndex, 1,this.mubanUpdateValue)
          this.mubanUpdate = false
        }
      }
    },
    gongxuRemove() {
      this.gongxu.splice(this.optionIndex, 1)
      this.optionUpdate = false
    },
    gongxumubanAdd() {
      let l = {
        id: -1,
        name: "新建的工序模板",
        processList:[]
      }
      this.gongxumubanList.push(l)
    },
    gongxuMubanRemove() {
      this.gongxumuban.processList.splice(this.mubanIndex, 1)
      this.mubanUpdate = false
    },
    isEmptyString(str){
      return (str === "" || str === null || str === undefined)
    },
    getCmdbId(name){
      let _cmdb = this.xinghaoListTotal.find(item => {
        return item.name !== null && item.name !== undefined && (item.name === name);
      });
      this.form.chanpinCmdbId = _cmdb.id
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        this.paperList = this.paperListTotal.filter(item => {
          return item.value !== null && item.value !== undefined && (item.value.toLowerCase()
              .indexOf(query.toLowerCase()) > -1);
        });
        this.$nextTick(()=>{
          this.loading = false;
        })
      } else {
        this.paperList = [];
      }
    },

    remoteMethod2(query) {
      if (query !== '') {
        this.loading2 = true;
        this.xinghaoList = this.xinghaoListTotal.filter(item => {
          return item.name !== null && item.name !== undefined && (item.name.toLowerCase()
              .indexOf(query.toLowerCase()) > -1);
        });
        this.$nextTick(()=>{
          this.loading2 = false;
        })
      } else {
        this.xinghaoList = [];
      }
    },
    getBlob() {
      return new Promise(resolve => {
        const xhr = new XMLHttpRequest();

        xhr.open('GET', this.url, true);
        xhr.responseType = 'blob';
        xhr.onload = () => {
          if (xhr.status === 200) {
            resolve(xhr.response);
          }
        };

        xhr.send();
      });
    },
    saveAs(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        const link = document.createElement('a');
        const body = document.querySelector('body');

        link.href = window.URL.createObjectURL(blob);
        link.download = filename;

        // fix Firefox
        link.style.display = 'none';
        body.appendChild(link);

        link.click();
        body.removeChild(link);

        window.URL.revokeObjectURL(link.href);
      }
    },
    img_download(){
      this.getBlob().then(blob => {
        this.saveAs(blob, this.QRName+".png");
      });
    },
    getPhotoUrl(name){
      this.QRName = name
      this.showQR = true
      this.url =
          // "https://back.yilanbiaoge.cn/getQRcode/"+
          "https://gate.yilanbiaoge.cn/back/getQRcode/"+
          // "http://localhost:8096/back/getQRcode/"+
          (name.replaceAll("+","%2B")
          .replaceAll("/","%26")
          .replaceAll("?","%3F")
          .replaceAll("#","%23")
          .replaceAll("&","%26")
          .replaceAll("=","%3D")
          .replaceAll("\n","")
          .replaceAll(" ",""))
      console.log( name, this.url)
    },



    createQR(id, pici) {
      console.log( id, pici)
      request.post(`/getFillCodel/${id}`,
          pici.replaceAll("/","&").replaceAll(" ","").replaceAll("\n","")).then(res => {
        console.log( res)
      })
    },
  }

}

</script>

<style scoped>

.text {
  font-size: 14px;
}

.item {
  padding: 18px 0;
}

.box-card {
  width: 300px;
}

.sort-rule-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.sort-empty {
  color: #909399;
  line-height: 32px;
}
</style>
